<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Landed Cost Components</h4>
                <p class="text-subtitle-1">List of landed cost components</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(permissions.landed_cost_component.create)">
                <v-btn color="primary" block @click="handleNew">
                    <v-icon left>mdi-plus</v-icon>
                    new component
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :footer-props="{'items-per-page-options': [5, 10, 25]}"
                    :options.sync="options"
                    :items="data"
                    :headers="headers"
                    :loading="loading"
                >
                <template v-slot:[`item.name`]="{item}">
                    <v-btn icon @click="handleOpen(item)" v-if="hasPermission(permissions.landed_cost_component.read)">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    {{ item.name }}
                </template>
            </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import service from './../../services/purchase/landedCostComponent';
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';
export default {
    data() {
        return {
            page: 1,
            serverItemsLength: 0,
            options: {},
            data: [],
            loading: false,
            permissions
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        }
    },
    computed: {
        headers() {
            return [
                { text: "Name", value: "name" },
                { text: "G/L Account", value: "ledger_account" }
            ]
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code);
        },
        handleNew() {
            this.$router.push({
                name: "LandedCostComponentCreate"
            })
        },
        fetch() {
            this.loading = true;
            service.index({...this.options}).then(res => {
                this.data = res.data.data;
                this.serverItemsLength = res.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleOpen(item) {
            const { id } = item;
            this.$router.push({
                name: "LandedCostComponentDisplay",
                params: { id }
            })
        }
    }
}
</script>

<style>

</style>